import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=4734cfcc&scoped=true&lang=html"
import script from "./AddProfile.vue?vue&type=script&lang=js"
export * from "./AddProfile.vue?vue&type=script&lang=js"
import style0 from "./AddProfile.vue?vue&type=style&index=0&id=4734cfcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4734cfcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4734cfcc')) {
      api.createRecord('4734cfcc', component.options)
    } else {
      api.reload('4734cfcc', component.options)
    }
    module.hot.accept("./AddProfile.vue?vue&type=template&id=4734cfcc&scoped=true&lang=html", function () {
      api.rerender('4734cfcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AddProfile.vue"
export default component.exports